// import
import { ReactNode} from 'react';

import { PASSPORT_LOOKUP_URL } from '@/lib/constants';

export type PassportTransferFAQItem = {
  question: string;
  answer: string | ReactNode;
}

const transferHelpPage = 'https://help.pbs.org/support/solutions/articles/12000048276-how-to-transfer-your-passport-benefit-';

export const PASSPORT_TRANSFER_NOT_SIGNED_IN_FAQ_BANK: PassportTransferFAQItem[] = [
  {
    question: 'Is this tool for me?',
    answer: 'You should use this tool if you need to change the email address you use to access your Passport account.'
  },
  {
    question: 'Do I have an active Passport benefit?',
    answer: <>Use the <a href={PASSPORT_LOOKUP_URL} target="_blank">PBS Passport Member Lookup Tool</a> to find out.</>
  },
  {
    question: 'How long will it take to transfer my Passport?',
    answer: 'Once you sign in and confirm, you will be able to transfer the Passport benefit immediately.'
  },
  {
    question: 'What information will I need to transfer my Passport?',
    answer: 'You will only need to know the email address and personal password for the PBS account you currently log in with for Passport access.'
  },
  {
    question: 'Will I need to enter my billing information or make a new donation in order to transfer my Passport?',
    answer: 'No, if you already have an active Passport benefit, you will not need to make a new donation to transfer your benefit and change the login account you use. You will not be asked for your billing information at any step.'
  },
  {
    question: 'I need more help.',
    answer: <>See <a href={transferHelpPage} target="_blank">this article</a> on the <a href="https://help.pbs.org/support/home" target="_blank">PBS Help site</a> for further assistance.</>
  }
]

export const PASSPORT_TRANSFER_SIGNED_IN_WITHOUT_PASSPORT_FAQ_BANK: PassportTransferFAQItem[] = [
  {
    question: 'How can I see the current Passport benefit status associated with my email?',
    answer: <>Use the <a href={PASSPORT_LOOKUP_URL} target="_blank">PBS Passport Member Lookup Tool</a> to find out.</>
  },
  {
    question: 'I think my station made a mistake with my Passport status',
    answer: <>Please contact your station directly to resolve this matter. <a href="https://www.pbs.org/stations/" target="_blank">Use this tool</a> to find your station’s contact information.</>
  },
  {
    question: 'I need more help.',
    answer: <>See <a href={transferHelpPage} target="_blank">this article</a> on the <a href="https://help.pbs.org/support/home" target="_blank">PBS Help site</a> for further assistance.</>
  }
]

export const PASSPORT_TRANSFER_ONE_MEMBERSHIP: PassportTransferFAQItem[] = [
  {
    question: 'Will I still be able to access Passport content with this account?',
    answer: 'No, the email address you previously used will no longer provide you access to Passport. When you transfer your Passport, you will choose a new email to log in with for access. Be sure to use this same email address when signing in across all PBS platforms.'
  },
  {
    question: 'I don’t have another Passport account.',
    answer: 'No problem. When you transfer your Passport, you will have the option to create a new PBS account.'
  },
  {
    question: 'Will my My List be available on my new account?',
    answer: 'No. Your Passport access is the only thing that will be transferred to your new account.'
  },
  {
    question: 'I need more help.',
    answer: <>See <a href={transferHelpPage} target="_blank">this article</a> on the <a href="https://help.pbs.org/support/home" target="_blank">PBS Help site</a> for further assistance.</>
  }
]
